/**
 * The `/analytics?view=` tab contract, in one place.
 *
 * AnalyticsTabs resolves an absent OR unrecognised `view` to Pipeline, so any nav
 * highlight that reconstructs that rule by hand drifts the moment the tab list
 * changes — `?view=bogus` renders Pipeline while the sidebar highlights nothing.
 */

export const ADMIN_VIEW_TABS = ['pipeline', 'clients', 'signups', 'analytics', 'users'] as const;
export type AdminViewTab = (typeof ADMIN_VIEW_TABS)[number];

export const ADMIN_VIEW_PATH = '/analytics';

/** True when `/analytics` is currently showing the Pipeline board.
 *  Pipeline is the fallback surface: it wins unless `view` names another real tab. */
export const isPipelineViewActive = (pathname: string, search: string): boolean => {
  if (pathname !== ADMIN_VIEW_PATH) return false;
  const view = new URLSearchParams(search).get('view');
  return !view || !ADMIN_VIEW_TABS.some((tab) => tab !== 'pipeline' && tab === view);
};
